<ng-container *transloco="let t; prefix: 'group-management.add-non-roster-user'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="quickAddForm" (ngSubmit)="submit()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div>
              <h3 class="text-base font-semibold text-primary-text">
                @if (mode() === 'guardian') {
                  {{ t('guardian-heading') }}
                } @else {
                  {{ t('permissions-heading') }}
                }
              </h3>
              <p class="mt-2 text-sm text-primary-text">
                @if (mode() === 'guardian') {
                  {{ t('guardian-instruction') }}
                } @else {
                  {{ t('permissions-instruction') }}
                }
              </p>
            </div>

            @if (duplicateEmailError()) {
              <div
                class="rounded-md border border-danger/30 bg-danger/10 px-3 py-3 text-sm text-primary-text"
                role="alert"
              >
                {{ t('duplicate-email') }}
              </div>
            }

            @if (permissionsRequiredError()) {
              <div
                class="rounded-md border border-danger/30 bg-danger/10 px-3 py-3 text-sm text-primary-text"
                role="alert"
              >
                {{ t('permissions-required') }}
              </div>
            }

            <div class="grid grid-cols-1 gap-2 sm:grid-cols-2">
              <ion-item lines="none">
                <ion-input
                  type="text"
                  [label]="t('first-name-placeholder')"
                  labelPlacement="stacked"
                  formControlName="firstname"
                  [errorText]="t('missing-fields')"
                  autocomplete="off"
                />
              </ion-item>
              <ion-item lines="none">
                <ion-input
                  type="text"
                  [label]="t('last-name-placeholder')"
                  labelPlacement="stacked"
                  formControlName="lastname"
                  [errorText]="t('missing-fields')"
                  autocomplete="off"
                />
              </ion-item>
            </div>

            <ion-item lines="none">
              <ion-input
                type="email"
                [label]="t('email-placeholder')"
                labelPlacement="stacked"
                formControlName="email"
                [errorText]="emailErrorText()"
                autocomplete="off"
              />
            </ion-item>

            @if (mode() === 'permissions') {
              <div class="space-y-2">
                <ion-item lines="none">
                  <ion-checkbox labelPlacement="end" formControlName="rolelead">
                    {{ t('leader-role') }}
                  </ion-checkbox>
                </ion-item>
                <ion-item lines="none">
                  <ion-checkbox labelPlacement="end" formControlName="rolefin">
                    {{ t('finance-role') }}
                  </ion-checkbox>
                </ion-item>
              </div>
            }
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 flex-col gap-3 border-t border-primary-border px-4 py-4">
        <button
          type="submit"
          class="w-full rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
          [disabled]="submitting()"
        >
          {{ t('submit-button') }}
        </button>
        <button
          type="button"
          class="w-full rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
          (click)="cancel()"
          [disabled]="submitting()"
        >
          {{ t('close') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
